//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
let d=[[[0,"ApplyRuleToggle",1,0],[0,"DisplayName",1,0],[0,"EnabledDTSubTypes",1,0],[0,"EnabledDimSubTypes",1,0],[0,"EnabledFCFSubTypes",1,0],[0,"EnabledStandards",1,0],[0,"FailureLevelEnum",1,0],[0,"IdentifierPrefix",1,0],[0,"SupportedPmiEnum",1,0]],[[["nDescription"],"GetDescription",{R_:{description:""}},0,0],[["description"],"SetDescription",{},1,0],[["nAlertMessage"],"GetAlertMessage",{R_:{alertMessage:""}},0,0],[["alertMessage"],"SetAlertMessage",{},1,0]],[]];
SPLM.MBD.AdvisorCustomCheckBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.AdvisorCustomCheckBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.AdvisorCustomCheckBuilder.FailureLevel = Object.freeze({
    "Error" : "Error", "Warning" : "Warning", "Information" : "Information"});

SPLM.MBD.AdvisorCustomCheckBuilder.SupportedPmi = Object.freeze({
    "DatumFeatureSymbol" : "DatumFeatureSymbol", "DatamTarget" : "DatamTarget", "Dimension" : "Dimension", "FeatureControlFrame" : "FeatureControlFrame", "SurfaceFinishSymbol" : "SurfaceFinishSymbol"});

export default SPLM;